<template>
    <div class="audit-msg">
        <el-button v-if="!isProcessMember" style="margin-bottom: 10px;" @click="close">返回</el-button>
        <slot v-if="!isProcessMember" name="outerBtn"></slot>
        <div v-if="isProcessMember">
            <el-button v-if="showStatus" style="margin-right: 10px;" @click="close">返回</el-button>
            <span v-if="showStatus" :class="'audit-status-block audit-status-' + auditData.auditStatus">{{ auditData.auditStatus_ }}</span>
            <div v-else>
                <el-button @click="close">返回</el-button>
                <slot name="innerBtn"></slot>
                <el-button type="primary" :loading="submitLoading" @click="checkAndSubmit">提交</el-button>
                <el-form style="margin-top: 10px;" ref="form" :model="form" :rules="rules" size="mini" label-position="left">
                    <el-form-item prop="operate">
                        <el-radio-group v-model="form.operate">
                            <el-radio v-for="(item, i) in operations" :label="item.operationCode" :key="item.operationCode">{{ item.operationName }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div>
            <el-row :gutter="10">
                <el-col :span="6" class="ellipsis-col">
                    <el-tooltip effect="dark" :content="auditData.supplierName || '---'" placement="top">
                        <div>供应商：{{ auditData.supplierName || '---' }}</div>
                    </el-tooltip>
                </el-col>
                <el-col :span="6">委派函类型：{{ auditData.delegateType_ || '---' }}</el-col>
                <el-col :span="6">申请人：{{ auditData.applicantName || '---' }}</el-col>
                <el-col :span="6">申请时间：{{ auditData.submitTime || '---' }}</el-col>
                <el-col :span="6" class="ellipsis-col">
                    <el-tooltip effect="dark" :content="auditData.approvalName || '---'" placement="top">
                        <div>审批人：{{ auditData.approvalName || '---' }}</div>
                    </el-tooltip>
                </el-col>
                <el-col :span="6">审批时间：{{ auditData.lastApproveTime || '---' }}</el-col>
                <el-col :span="6">审批进度：{{ auditData.auditStatus_ || '---' }}</el-col>
                <el-col :span="6">审批类型：{{ auditData.auditType_ || '---' }}</el-col>
                <el-col :span="6">创建渠道：{{ auditData.dataSource || '---' }}</el-col>
            </el-row>
        </div>
        <!-- <div v-else-if="isSupplier">
            <el-row :gutter="10">
                <el-col :span="8">审批类型：{{ auditData.auditType_ }}</el-col>
                <el-col :span="8">委派函类型：{{ auditData.delegateType_ }}</el-col>
                <el-col :span="8">审批进度：<span v-if="!!auditData.auditStatus_" class="audit-status">{{ auditData.auditStatus_ }}</span></el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="8">申请时间：{{ auditData.submitTime }}</el-col>
                <el-col :span="8">审批时间：{{ auditData.lastApproveTime }}</el-col>
                <el-col :span="8">申请人：{{ auditData.applicantName }}</el-col>
            </el-row>
        </div> -->
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { dictWithUrl } from '@/components/lots/api';
import { getApprovalDetail, getOperation, approvalDelegate } from '../../../api/warehouseResourceManagement/warehouseDelegationLetter.js'
import { AUDIT_STATUS } from './constant.js'

export default {
    props: {
        warehouseDelegateNo: {
            type: String,
            default() {
                return '';
            }
        },
    },
    data() {
        return {
            submitLoading: false,
            form: {
                operate: null
            },
            rules: {
                operate: [{ required: true, message: '请选择提交结果', trigger: ['change'] }],
            },
            dict: {},
            auditData: {}, // 审批信息
            operations: [], // 审批提交选项
        }
    },
    computed: {
        ...mapGetters(['user']),
        // 当前账号是否为申请人
        isApplicant() {
            return this.auditData.applicantCode && this.auditData.applicantCode === this.user.userCode
        },
        // 当前账号是否为流程节点(申请人、审批人)之一
        isProcessMember() {
            let isApprover = false
            if (this.auditData.approvalCode) {
                isApprover = this.auditData.approvalCode.split(',').includes(this.user.userCode)
            }
            return isApprover || this.isApplicant
        },
        showStatus() {
            // 通过，驳回，撤回
            return [AUDIT_STATUS.ADOPT, AUDIT_STATUS.REJECT, AUDIT_STATUS.WITHDRAW].includes(this.auditData.auditStatus)
        },
    },
    inject: ['paydayCheck'],
    methods: {
        close(){
            let path = this.$store.state.supplier ? '/lsrm/warehouseDelegationLetter' : '/warehouseDelegationLetter'
            this.$router.replace(path)
        },
        checkAndSubmit() {
            this.$refs.form.validate().then(() => {
                // 起草人提交 需要校验
                if (this.form.operate === 'draft_submit') {
                    this.paydayCheck(this.submit)
                } else {
                    this.submit()
                }
            })
        },
        submit() {
            const params = {
                operate: this.form.operate,
                auditMipId: this.auditData.auditMipId,
                operatorCode: this.user.userCode,
                operator: this.user.userName,
            }
            this.submitLoading = true
            approvalDelegate(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('提交成功!')
                    this.$emit('submit')
                }
            }).finally(() => { this.submitLoading = false })
        },
        getDetail() {
            getApprovalDetail(this.warehouseDelegateNo).then(res => {
                if (res && +res.code === 0) {
                    this.auditData = res.data
                    this.auditData.auditType_ = this.dict.WAREHOUSE_DELEGATE_AUDIT_TYPE[this.auditData.auditType]
                    this.auditData.delegateType_ = this.dict.WAREHOUSE_DELEGATE_TYPE[this.auditData.delegateType]
                    this.auditData.auditStatus_ = this.dict.WAREHOUSE_DELEGATE_AUDIT_STATUS[this.auditData.auditStatus]

                    if (!this.showStatus) {
                        this.setOperateOptions()
                    }
                }
            })
        },
        setOperateOptions() {
            getOperation(this.warehouseDelegateNo).then(res => {
                if (res && +res.code === 0) {
                    this.operations = res.data.length ? res.data : []
                }
            })
        },
    },
    mounted() {
        dictWithUrl('WAREHOUSE_DELEGATE_AUDIT_TYPE,WAREHOUSE_DELEGATE_TYPE,WAREHOUSE_DELEGATE_AUDIT_STATUS').then(res => {
            if (res && +res.code === 0) {
                this.dict = res.data
                this.getDetail()
            }
        })
    },
    activated() {
        dictWithUrl('WAREHOUSE_DELEGATE_AUDIT_TYPE,WAREHOUSE_DELEGATE_TYPE,WAREHOUSE_DELEGATE_AUDIT_STATUS').then(res => {
            if (res && +res.code === 0) {
                this.dict = res.data
                this.getDetail()
            }
        })
    },
}
</script>
<style lang="less" scoped>
.audit-msg {
    font-weight: 700;
    border-bottom: 1px solid #ddd;
    padding: 0 20px 10px;
    margin-bottom: 10px;
    // height: 67px;
    // line-height: 23px;

    /deep/ .el-col {
        margin-bottom: 10px;
    }

    /deep/ .el-form-item__error {
        font-weight: normal;
    }

    .audit-status {
        display: inline-block;
        padding: 3px 20px;
        margin-left: 10px;
        color: white;
        background-color: #00bfbf;
        border-radius: 4px;
    }

    .ellipsis-col {
        & > div {
            overflow: hidden;
            width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .audit-status-block {
        display: inline-block;
        padding: 5px 10px;
        margin-bottom: 10px;
        color: white;
        border-radius: 3px;
        font-weight: normal;
    }

    .audit-status-20 {
        background-color: #00bcbf;
    }

    .audit-status-30 {
        background-color: #d9001b;
    }

    .audit-status-80 {
        background-color: #f59a23;
    }
}
</style>